import React from "react";
import GlobalStyle from "./styles/GlobalStyles";
import Routes from "./routes/Routes";
import GlobalProvider from "./context/GlobalContext";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import useSetTitle from "./hooks/useSetTitle";

// inicio del app
function App() {
   useSetTitle("");

   return (
      <Router>
         <GlobalProvider>
            <GlobalStyle />
            <Routes />
         </GlobalProvider>
      </Router>
   );
}

export default App;
